export const AUTHORITY = {
  Z: 'Z',
  P: 'P',
  U: 'U',
  V: 'V',
};

export const ACTIVATION_STATUSES = [
  { code: 'ACTIVE_COMPLETED', label: 'Active Completed' },
  { code: 'PENDING_INPROGRESS', label: 'Pending In Progress' },
];

export const COMPANY_TYPE = {
  PRODUCER: 'PRODUCER',
  ADVERTISER: 'ADVERTISER',
};

export const ROUTES = {
  PROJECT_NEW: '/projects/new/company',
  PROJECT_DASHBOARD: '/projects',
};

export const TABLE_COMPONENTS = {
  HEADER: 'agColumnHeader',
};

export const GRID_DEFAULTS = {
  debounceVerticalScrollbar: true,
  ensureDomOrder: true,
  enableCellTextSelection: true,
};

export const LABEL_KEYS = {
  USER: 'user',
  EMAIL: 'email',
  RIGHTS: 'Ownership',
  DECISION_MAKER: 'decisionMaker',
  ACTION: 'action',
};

export const USER_INVITATION_MESSAGES = {
  ALREADY_EXISTS: {
    title: 'User Invitation',
    description: 'This user is already in the list!',
    confirmBtn: 'OK',
  },
  INVITE_SENT: (email: string) => ({
    title: 'User Invitation',
    description: `We haven't found a user with ${email} email address. We've sent an invite to join MTM.`,
    confirmBtn: 'Accept',
  }),
};

export const WORKSPACE_PROJECT_COLUMNS = {
  ACTION: {
    FIELD: 'action',
    HEADER: 'Action',
    MIN_WIDTH: 280,
    FLEX: 0,
  },
  USER: {
    FIELD: 'fullName',
    HEADER: 'User',
    MIN_WIDTH: 320,
    FLEX: 1,
  },
  EMAIL: {
    FIELD: 'email',
    HEADER: 'Email',
    MIN_WIDTH: 240,
    FLEX: 1,
  },
  OWNERSHIP: {
    FIELD: 'rights',
    HEADER: 'Ownership',
    MIN_WIDTH: 140,
    FLEX: 1,
  },
  DECISION_MAKER: {
    FIELD: 'decisionMaker',
    HEADER: 'Decision Maker',
    MIN_WIDTH: 280,
    FLEX: 1,
  },
};

export const SORT_STATES = {
  ASC: 'asc',
  DESC: 'desc',
  NONE: '',
};

export const CSS_CLASSES = {
  HEADER_DROPDOWN_OPEN: 'header-dropdown-open',
  ROW_OPEN: 'row-open',
};
